import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import SolutionInfo from "./SolutionInfo";
import RouteSolutionHeader from "./RouteSolutionHeader";
import { Collapse } from "@material-ui/core";

class RouteSolution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
  }

  toggleRecommendedPickup = () => {
    this.setState((prevState) => ({
      ...prevState,
      expanded: !prevState.expanded,
    }));
  };

  render() {
    const {
      classes,
      selectedDriverAssignmentId,
      driverAssignments,
      selectedPickupId,
      onDriverSelection,
      onPickupSelection,
    } = this.props;
    const { expanded } = this.state;

    return (
      <>
        <RouteSolutionHeader
          count={driverAssignments.length}
          expanded={expanded}
          onToggle={this.toggleRecommendedPickup}
          optimizationRunTime={this.props.optimizationRunTime}
        />
        <div
          className={`${expanded ? classes.minHeightAssignDriver : ""} ${
            classes.assignedDriver
          } customScroll`}
        >
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            {driverAssignments.length > 0 ? (
              driverAssignments.map((driverAssignment, index) => (
                <SolutionInfo
                  classes={classes}
                  key={index}
                  isSelected={selectedDriverAssignmentId.includes(
                    driverAssignment.driverId
                  )}
                  driverAssignment={driverAssignment}
                  onDriverSelection={onDriverSelection}
                  onPickupSelection={onPickupSelection}
                  selectedPickupId={selectedPickupId}
                />
              ))
            ) : (
              <div className={classes.noData}>No Data Available</div>
            )}
          </Collapse>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(RouteSolution);
